import { useQuery } from '@tanstack/react-query';
import { invoiceApi, invoiceItemDtlApi } from '../../api/api';

export const useInvoices = (options = {}) =>
  useQuery({
    queryKey: ['invoices'],
    queryFn: () => invoiceApi.getAll(),
    ...options,
  });

export const useInvoiceItems = (options = {}) =>
  useQuery({
    queryKey: ['invoice-items'],
    queryFn: () => invoiceItemDtlApi.getAll(),
    ...options,
  });
